const quoteData = {
  meta: {
    title: "Nature To Thrive - Website Rebuild Proposal",
    clientName: "Nature To Thrive",
    url: "https://naturetothrive.com.au/",
    date: "2026-05-14",
    quoteNumber: "Q-2026-NATURETOTHRIVE-WEB",
    preparedBy: "Jason Toomer",
    summary: [
  "Hi Aphrodite, thank you for the opportunity to review the Nature To Thrive website and prepare this proposal.",
  "This proposal is based on rebuilding the current website into a modern, calm, mobile-first brochure website that better reflects your professional services, values, and client care.",
  
  "At 2merative we do not build template websites. Every website is custom built to suit the business, the audience, and the journey we want visitors to take.",
  "For Nature To Thrive this means a custom React.js website with a professional brochure-style layout, improved mobile experience, clear service information, better calls to action, and stronger SEO and GEO foundations.",
  "A structural concept build has already been completed and is currently being reviewed. This allows the project to move forward from a strong visual and structural foundation rather than beginning from a blank concept stage.",
  "The proposal also includes working through the handover process from the previous provider where required, including assistance with domain transition, hosting coordination, local configuration, DNS guidance, and professional email configuration support if needed.",
  "The goal is not simply to replace the current website, but to create a more trustworthy, modern, and client-friendly online presence that helps people understand your services and take the next step with confidence.",
  "",
  "Regards,",
  "Jason"
]
  },

  business: {
    name: "2merative",
    abn: "61775724636",
    email: "hello@2merative.com",
    phone: "0498 135 744"
  },

  options: [
    {
      id: "react-brochure-website-rebuild",
      label: "Option 1: Full React.js brochure website rebuild",
      sections: {
        projectApproach: [
          "Custom React.js brochure website built with a calm, modern, mobile-first design.",
          "Designed to improve professional presentation, trust, readability, and enquiry flow.",
          "Clear homepage structure with stronger messaging, service pathways, and calls to action.",
          "Dedicated page or section structure for key services, about information, bookings, contact, and supporting content.",
          "Improved mobile layout so visitors can easily read, navigate, and take action from any device.",
          "SEO and GEO foundations included to support Google search visibility and AI search understanding.",
          "Built using a clean component-based structure for speed, maintainability, and future flexibility."
        ],

        oneOff: [
          { item: "Discovery, planning, and website structure", cost: 100 },
          { item: "Custom React.js brochure website design and build", cost: 1600 },
          { item: "Mobile-first responsive layout and styling", cost: 250 },
          { item: "Homepage rebuild with clear service and enquiry flow", cost: 350 },
          { item: "Core internal pages or sections", cost: 250 },
          { item: "Service content layout and presentation", cost: 250 },
          { item: "Contact and enquiry pathway setup", cost: 250 },
          { item: "SEO and GEO foundation setup including metadata structure", cost: 150 },
         
          { item: "Sitemap and robots.txt setup", cost: 50 },
          { item: "Performance optimisation and launch testing", cost: 200 },
          { item: "Domain and deployment support", cost: 0 },
          { item: "30 days post-launch technical monitoring included", cost: 0 },
          { item: "12 months managed support included (up to 1 hour per month, no rollover)", cost: 0 }
        ],

        recurring: [
          { item: "Website hosting", costMonthly: 0, costYearly: 220 },
          { item: "Professional email account per email address", costMonthly: 0, costYearly: 25 }
        ]
      }
    }
  ],

  gstRate: 0,

  totals: {
    option1BuildSubtotal: 5350,
    discountedBuildTotal: 5350,
    annualHosting: 220,
    emailPerUser: 25
  },

  notes: [
    "This proposal is for a custom React.js brochure website rebuild for Nature To Thrive.",
    "The rebuild will focus on professional presentation, mobile experience, clear service communication, improved customer flow, faster performance, SEO foundations, GEO foundations, and trust-building content.",
    "The website will be built with a mobile-first approach.",
    "The project includes sitemap and robots.txt setup to support Google indexing.",
    "The project includes foundational GEO structure to help AI search tools better understand the business, services, location, and expertise.",
    "Professional domain-based email setup can be included or configured if required.",
    "Final written content, service details, practitioner information, images, privacy content, booking links, and policies are to be provided by the client unless otherwise agreed.",
    "Logo files should be provided in high-quality format, preferably SVG, PNG, or PDF.",
    "Domain name will be utilised assuming the client has ownership and control of the domain.",
    "New website build can be deployed into the existing hosting platform if already paid for, subject to admin access and hosting stack validation.",
    "Website hosting is $220 per year from year 2 onward if hosted by 2merative.",
    "Additional professional email accounts are available at $25 per email per year.",
    "30 days post-launch technical monitoring is included for technical issues related to the new website build.",
    "Ongoing content updates, new pages, larger layout changes, booking platform changes, or third-party integrations are outside this proposal unless separately agreed."
  ],

  acceptance: {
    validUntil: "2026-05-28",
    paymentTerms: "50% deposit on acceptance. Remaining 50% due one week prior to deployment."
  }
};

export { quoteData };
export default quoteData;